const snackProductTypeEnum = {
  Snack: 0,
  Merchandising: 1,
};

const kioskTypeEnum = {
  Cards: 0,
  Snack: 1,
  Merchandising: 2,
};

const purchaseSubTypeEnum = {
  CbDirect: -1, // Snack et Merchandising achetés par CB directement
  Cash: 0,
  Cb: 1
};

const revenueSubTypeEnum = {
  Games: -1,
  Events: -2,
  Snack: snackProductTypeEnum.Snack,
  Merchandising: snackProductTypeEnum.Merchandising
};

const siteTopGroupEnum = {
  FRANCHISE: 1,
  NOT_FRANCHISE: 2,
  LTDN: 3,
};

const tvaPercentageRateEnum = {
  FIVE_POINT_FIVE: 5.5,
  TEN: 10,
  TWENTY: 20
}

export { snackProductTypeEnum, kioskTypeEnum, purchaseSubTypeEnum, revenueSubTypeEnum, siteTopGroupEnum, tvaPercentageRateEnum };
